import { useMutation } from "@tanstack/react-query";
import { justifyStrandLosses } from "../repositories/caster.repositories";

interface JustifyStrandLossesParams {
  processId: number;
  strandLossCodeId: number;
  comments: string | null;
}

export const useJustifyStrandLossesMutation = () =>
  useMutation({
    mutationFn: async ({
      processId,
      strandLossCodeId,
      comments,
    }: JustifyStrandLossesParams) => {
      const response = await justifyStrandLosses(
        processId,
        strandLossCodeId,
        comments,
      );
      if (!response.ok) throw new Error(response.message);
      return response;
    },
  });
